import { useContext, useEffect, useState } from "react"
import { AppContext } from "../../context/context"

const BrandAuthViewLink = (params) => {

	let { seller_vendor, tab, ads, authorizedMarketPlace, css, className, sellerVendorTable } = params

	const { neonUser, adsIssueList, clientAuthList, getAdsAuthStatus, fetchDataV2 } = useContext(AppContext)

	const [authUrl, setAuthUrl] = useState("")
	const [authIssue, setAuthIssue] = useState(false)

	const createUrl = () => {
		let x = authorizedMarketPlace;
		let url = [
			`region=${x.marketPlace.regionCode.code}`,
			`country=${x.marketPlace.countrycode}`,
			`api_type=${(() => {
				if (seller_vendor && tab == 'ppc') return 'adsapi';
				if (seller_vendor && tab == 'dsp') return 'dsp';
				return 'spapi'
			})()}`,
			`companyName=${x.brand}`,
			`type=${(() => {
				if (ads) return x.account_type == 'ads' ? 'seller' : x.account_type
				return x.account_type == 'seller' ? 'seller_central' : x.account_type == 'vendor' ? 'vendor_central' : ''
			})()}`,
			`agency=${neonUser.agency_name}`,
			`agency_email=${neonUser.agency_id}`,
			`email=${x.brand_entity_id}`,
		]

		url = encodeURI(url.join("&"))
		url = `https://authorize.biusers.com/?&` + url
		setAuthUrl(url)
		return url
	}

	const getAuthProfileInfoStatus = async () => {

		let query1 = 'AUTH_PROFILE_INFO_STATUS', params1 = [authorizedMarketPlace.profile.client_id]

		let resp = await fetchDataV2(query1, params1, "/neon-market-v2")

		// console.log({resp, query1, params1})

		if (resp.length == 0) {
			setAuthIssue(true)
			return
		}

		resp = resp[0]
		// console.log("ISSUE", !resp.auth || !resp.profile || !resp.info)
		setAuthIssue(!resp.auth || !resp.profile || !resp.info)
		return
	}

	useEffect(() => {
		if (!!sellerVendorTable) {
			// let authIssueList = clientAuthList.filter(x => !x.status).map(x => x.client_info_id)
			// let clientList = sellerVendorTable.map(x => x.client_id)
			// let issue = authIssueList.filter(xx => clientList.includes(xx)).length > 0
			// setAuthIssue(issue)
			getAuthProfileInfoStatus()
		}
	}, [clientAuthList, sellerVendorTable])

	useEffect(() => {
		createUrl()
	}, [tab])

	useEffect(() => {
		if (!!sellerVendorTable && sellerVendorTable.length > 0 && !params.central) getAdsAuthStatus(sellerVendorTable)
	}, [sellerVendorTable, tab])

	useEffect(() => {
		createUrl()
		// console.log(params)

	}, [])

	if (!!authUrl) return (
		<a href={authUrl} title={authUrl} target="_blank" style={css} className={className}>
			{params.central ?
				<span className="poppins">
					{authorizedMarketPlace?.profile?.client_id ? "Reauthenticate" : "Authenticate"}
				</span>
				:
				adsIssueList.length > 0 ?
					<span className="poppins">Authenticate</span>
					:
					authIssue ?
						<span className="poppins">Reauthenticate</span>
						:
						<span className="poppins">Authenticate</span>
			}
		</a>
	)
	else return null
}

export default BrandAuthViewLink